export const workflowConstants = {
    NEW_LOAN_WORKFLOW: 0,
    NEW_LOAN_LOGGED_IN_WORKFLOW: 1,
    NEW_LOAN_LANDING_PAGE_WORKFLOW: 2,
    REFINANCE_INCREASE_LOAN_WORKFLOW: 3,
    APPLICATION_RECEIVED_WORKFLOW: 4,
    EXISTING_CUSTOMER_REGISTRATION_WORKFLOW: 5,
    REFINANCE_INCREASE_LOAN_DISABLED_FUNDING_WORKFLOW: 6,
    GUEST_PAYMENT_REGISTRATION: 7
}